import * as yup from "yup";

const tarifaPermisionariosValidacionEsquema = yup.object().shape({       
         tarifa: yup.mixed().required(),
         tipoUnidad: yup.mixed().required(),
         permisionarioId: yup.mixed().required(),
         tipoViaje: yup.mixed().required(),
    })
export default tarifaPermisionariosValidacionEsquema ;
